import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, getInitialLanguage, saveLanguage } from '../i18n/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getInitialLanguage());

  const changeLanguage = (newLang) => {
    setLanguage(newLang);
    saveLanguage(newLang);
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  useEffect(() => {
    // Actualizar el atributo lang del HTML
    document.documentElement.lang = language;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

